import React, { Component, cloneElement } from 'react';
import { Button, Icon, message } from 'antd';
import moment from 'moment';
import {
  Input,
  TextArea,
  Radio,
  Select,
  CheckBox,
  DatePicker,
  SubmitButton,
  // UploadImage,
  NotEditableItem,
  Autocomplete,
} from './components';
import { validate } from '../../utils/validator';
import FormItem from './FormItem';
import { apiErrorToStr } from '../../utils';
import { CONNECT_TYPES, ResponsiveMessages } from './entities';

class Form extends Component {
  validationSchema = null;

  state = {
    data: {},
    error: {},
  };

  constructor(props) {
    super(props);

    this.initData = this.initData.bind(this);
    this.getStorage = this.getStorage.bind(this);
    this.connectToData = this.connectToData.bind(this);
    this.updateData = this.updateData.bind(this);
    this.onChanged = this.onChanged.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onInputNumberChange = this.onInputNumberChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onSwitchChange = this.onSwitchChange.bind(this);
    this.onDateTimePickerChange = this.onDateTimePickerChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.setNextStep = this.setNextStep.bind(this);
    this.getValue = this.getValue.bind(this);
    this.getError = this.getError.bind(this);
    this.setError = this.setError.bind(this);
    this.validate = this.validate.bind(this);
    this.renderInput = this.renderInput.bind(this);
    this.renderSelect = this.renderSelect.bind(this);
    this.renderRadio = this.renderRadio.bind(this);
    this.renderDatePicker = this.renderDatePicker.bind(this);
    // this.renderUploadImage = this.renderUploadImage.bind(this);
    this.renderAutocomplete = this.renderAutocomplete.bind(this);
    this.renderButton = this.renderButton.bind(this);
    this.renderSubmitButton = this.renderSubmitButton.bind(this);
    this.renderBackButton = this.renderBackButton.bind(this);
    this.renderCancelButton = this.renderCancelButton.bind(this);
    this.renderNotEditableItem = this.renderNotEditableItem.bind(this);
  }

  // Call only on constructor
  initData(data) {
    this.state.data = {
      ...this.state.data,
      ...data,
    };
  };

  getStorage() {
    return this.state;
  }

  connectToData(name, component, type) {
    let onChange = this.onChange(name);

    switch (type) {
      case CONNECT_TYPES.RADIO:
      case CONNECT_TYPES.INPUT:
        onChange = this.onInputChange;
        break;

      case CONNECT_TYPES.INPUT_NUMBER:
        onChange = this.onInputNumberChange(name);
        break;

      case CONNECT_TYPES.SWITCH:
        onChange = this.onSwitchChange(name);
        break;

      case CONNECT_TYPES.DATE_PICKER: {
        const { format } = component.props;
        onChange = this.onDateTimePickerChange(name, format);
        break;
      }

      case CONNECT_TYPES.CHECKBOX: {
        onChange = this.onCheckboxChange;
        break;
      }
    }

    return cloneElement(component, {
      editable: this.state.editable,
      name,
      value: this.getValue(name),
      error: this.getError(name),
      onChange,
    });
  };

  updateData(name, value, onChanged) {
    const { error, data } = this.state;
    data[name] = value;

    if (error[name]) {
      error[name] = '';
    }

    if (this.props.error) {
      this.props.clearError && this.props.clearError();
    }

    this.setState({
        error: { ...error },
        data: { ...data },
      },
      () => {
        onChanged && onChanged(value);
        this.onChanged(name, value);
      });
  };

  onChanged(name, value) {

  }

  onChange(name, onChanged) {
    return (value) => {
      this.updateData(name, value, onChanged);
      return false; // need for upload element
    };
  };

  onInputChange(e) {
    const { name, value } = e.target;
    this.updateData(name, value);
  }

  onCheckboxChange(e) {
    const { name, checked } = e.target;
    this.updateData(name, checked);
  };

  onInputNumberChange(name) {
    return (value) => {
      if (typeof value === 'string') {
        const match = value.match(/\d+\.{1}\d*/g);
        value = match ? match.join('') : undefined;
      }
      this.updateData(name, value);
    };
  }

  onSwitchChange(name) {
    return (checked) => {
      this.updateData(name, checked ? 1 : 0);
    };
  }

  onDateTimePickerChange(name, format) {
    return (value) => {
      /*if (value) {
        value = value.toDate();
      }*/
      this.updateData(name,
        moment(value)
          .format(format));
    };
  }

  onSubmit(e) {
  }

  onCancel(e) {
    this.props.history.goBack();
  }

  setNextStep(step) {
    const { data } = this.getStorage();
    this.props.updateData({
      ...data,
      step,
    });
  }

  getValue(key) {
    return this.getStorage().data[key];
  }

  getError(key) {
    return this.state.error[key];
  }

  setError(key, value) {
    return this.setState((prev) => ({
      error: {
        ...prev.error,
        [key]: value,
      },
    }));
  }

  validate() {
    const { data } = this.getStorage();
    const validation = validate(this.validationSchema, data);
    
    if (Object.keys(validation.errors).length > 0) {
      console.log('VALIDATION ERROR: ', validation.errors);
      this.setState({ error: validation.errors });
      return false;
    }

    console.log('VALIDATION DATA', validation.data);
    return validation.data;
  }

  async responsiveHandle(handle, messages) {
    if (!(messages instanceof ResponsiveMessages)) {
      throw new Error('Wrong instance of Messages');
    }

    const stopLoading = message.loading(messages.onLoading(), 0);
    try {
      await handle();
      message.success(messages.onSuccess());
    } catch (e) {
      const preparedError = typeof messages.onError === 'function'
        ? messages.onError(apiErrorToStr(e))
        : apiErrorToStr(e);
      preparedError && message.error(preparedError);
    }
    stopLoading();
  }

  renderFormWrapper = (name, options) => {
    return this.connectToData(name, (
      <FormItem {...options} />
    ));
  };

  renderInput(name, options) {
    return this.connectToData(name, (
      <Input
        required
        autoComplete="none"
        {...options}
      />
    ), CONNECT_TYPES.INPUT);
  }

  renderTextArea(name, options) {
    return this.connectToData(name, (
      <TextArea
        required
        autoComplete="none"
        {...options}
      />
    ), CONNECT_TYPES.INPUT);
  };

  renderSelect(name, { data, ...options }) {
    return this.connectToData(name, (
      <Select
        autoComplete="none"
        {...options}
      >
        {Select.prepareOptions(data)}
      </Select>
    ));
  }

  renderRadio(name, { data, ...options }) {
    return this.connectToData(name, (
      <Radio
        {...options}
      >
        {Radio.prepareOptions(data)}
      </Radio>
    ), CONNECT_TYPES.RADIO);
  }

  renderCheckBox(name, options) {
    return this.connectToData(name, (
      <CheckBox {...options} />
    ), CONNECT_TYPES.CHECKBOX);
  }

  renderDatePicker(name, options) {
    return this.connectToData(name, (
      <DatePicker
        {...options}
      />
    ), CONNECT_TYPES.DATE_PICKER);
  }

  /*renderUploadImage(name, options) {
    return this.connectToData(name, (
      <UploadImage
        {...options}
      />
    ));
  }*/

  renderAutocomplete(name, options) {
    return this.connectToData(name, (
      <Autocomplete
        {...options}
      />
    ));
  }

  renderButton(name, options) {
    return (
      <SubmitButton {...options}>
        {name}
      </SubmitButton>
    );
  }

  renderSubmitButton(name = 'Save', options) {
    return (
      <SubmitButton type="primary" htmlType="submit" onClick={this.onSubmit} {...options}>
        {name}
      </SubmitButton>
    );
  }

  renderBackButton(name = 'Back') {
    return (
      <Button type="primary" onClick={this.onCancel}>
        <Icon type="arrow-left" />
        {name}
      </Button>
    );
  }

  renderCancelButton(name = 'Cancel', options) {
    return (
      <Button onClick={this.onCancel} {...options}>
        {name}
      </Button>
    );
  }

  renderNotEditableItem(name, options) {
    return this.connectToData(name, <NotEditableItem {...options} />);
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/BaseForm/indexNew.js